export default "__VITE_ASSET__DSNtleEo__"